import {
  Battery20,
  Battery30,
  Battery50,
  Battery60,
  Battery80,
  Battery90,
  BatteryFull,
  BatteryAlert,
} from "@mui/icons-material";

/**
 * Maps a battery percentage to the closest MUI battery icon component.
 * Accepts a number or a percentage string (e.g. "85%"); invalid values
 * resolve to the alert icon.
 *
 * @param {number|string} level - Battery percentage (0-100)
 * @returns {React.ComponentType} The matching MUI icon component
 */
export const getBatteryIcon = (level) => {
  const numeric =
    typeof level === "string" ? Number(level.replace("%", "")) : level;

  if (numeric === null || numeric === undefined || Number.isNaN(numeric)) {
    return BatteryAlert;
  }
  if (numeric >= 90) return BatteryFull;
  if (numeric >= 80) return Battery90;
  if (numeric >= 60) return Battery80;
  if (numeric >= 50) return Battery60;
  if (numeric >= 30) return Battery50;
  if (numeric >= 20) return Battery30;
  if (numeric >= 10) return Battery20;
  return BatteryAlert;
};
